module.exports = __webpack_public_path__ + "img/no-profile-image.6becc116.png";